import { t as e } from "./collectionIcon-4B-wWD3h.js";
import { jsx as t, jsxs as n } from "react/jsx-runtime";
import { EmptyState as r, FlexBox as i, Text as a } from "@dixa/lib-shared-habla";
import o from "classnames";
var s = {
	noArticleSelected: "_noArticleSelected_1chhh_1",
	knowledgeBaseCard: "_knowledgeBaseCard_1chhh_5",
	knowledgeBaseCardHover: "_knowledgeBaseCardHover_1chhh_14"
}, c = () => /* @__PURE__ */ t(i, {
	flexDirection: "column",
	alignItems: "center",
	justifyContent: "start",
	gap: "500",
	className: s.noArticleSelected,
	children: /* @__PURE__ */ t(r, {
		icon: "file-text",
		title: "Select an article",
		description: "Select an article to view."
	})
}), l = ({ collectionId: r, hoverEffect: c, iconColor: l, description: u, title: d }) => {
	if (!r) throw Error("No collectionId found");
	let f = o(s.knowledgeBaseCard, { [s.knowledgeBaseCardHover]: c });
	return /* @__PURE__ */ n(i, {
		className: f,
		children: [/* @__PURE__ */ t(e, { color: l }), /* @__PURE__ */ n(i, {
			flexDirection: "column",
			justifyContent: "center",
			children: [/* @__PURE__ */ t(a.Heading, {
				variant: "heading-1",
				children: d
			}), u && /* @__PURE__ */ t(a.Paragraph, {
				variant: "2",
				children: u
			})]
		})]
	});
};
export { l as KnowledgeBaseCard, c as default };

//# sourceMappingURL=noArticleSelected-I9mJHicx.js.map